"use client";
import { PrismicNextLink } from "@prismicio/next";
import { PrismicRichText } from "@prismicio/react";
import ChevronUp from "atd-icons/dist/ChevronUp";
import ChevronDown from "atd-icons/dist/ChevronDown";
import { useRef, useState } from "react";

export default function SideNavDropdownLink({ subLinks, item }) {
  const [expanded, setExpanded] = useState(false);
  const contentRef = useRef(null);

  function onClickHandler() {
    setExpanded((prev) => !prev);
  }

  return (
    <div className="text-[#1F2223] text-base mb-[8px] md:mb-[16px] last:mb-0">
      <div
        onClick={onClickHandler}
        className="cursor-pointer flex items-center gap-[10px] duration-200 "
      >
        {item.label}
        {expanded ? (
          <ChevronUp size={20} color="#1F2223" />
        ) : (
          <ChevronDown size={20} color="#1F2223" />
        )}
      </div>

      <div
        className={`overflow-hidden ${expanded ? "mb-[8px] md:mb-[16px] " : ""}`}
        style={{
          maxHeight: expanded ? `${contentRef.current.scrollHeight}px` : "0px",
          transition: "all 0.4s",
        }}
      >
        <div
          ref={contentRef}
          className={`${expanded ? "pt-[4px]" : ""} duration-200`}
        >
          <PrismicRichText
            components={{
              listItem: ({ children }) => (
                <li className="pl-[23px] text-base text-[#646464] hover:text-[black] duration-200">
                  {children}
                </li>
              ),
              hyperlink: ({ children, node }) => (
                <PrismicNextLink
                  field={node.data}
                  className="line-block text-[15px] h-[26px]"
                >
                  {children}
                </PrismicNextLink>
              ),
            }}
            field={subLinks}
          />
        </div>
      </div>
    </div>
  );
}
